import { render, staticRenderFns } from "./OrgChartTemp1.vue?vue&type=template&id=2a41f157&scoped=true&"
import script from "./OrgChartTemp1.vue?vue&type=script&lang=js&"
export * from "./OrgChartTemp1.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTemp1.vue?vue&type=style&index=0&id=2a41f157&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41f157",
  null
  
)

export default component.exports